import { Component, inject } from '@angular/core';
import { FilesManagerComponent } from '../../../../components/services/files-manager/files-manager.component';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { FolderGlobalStore } from '../../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../shared/shared.global-service';

@Component({
    selector: 'app-folder-documents-dialog',
    templateUrl: './folder-documents-dialog.component.html',
    styleUrl: './folder-documents-dialog.component.scss',
    imports: [
        FilesManagerComponent,

    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class FolderDocumentsDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }
}
